import { OutcomeData } from './case-outcome.types';

export enum CaseStatus {
  None = 'None',
  Draft = 'Draft',
  OpoDraft = 'OpoDraft',
  TXCenterDraft = 'TXCenterDraft',
  ClinicalScreening = 'ClinicalScreening',
  Declined = 'Declined',
  PendingLogistics = 'PendingLogistics',
  ResourceDeployed = 'ResourceDeployed',
  ResourcesBooked = 'ResourcesBooked',
  AtDonorHospital = 'AtDonorHospital',
  OrganOnOCS = 'OrganOnOCS',
  DeployedToTXCenter = 'DeployedToTXCenter',
  AtTXCenter = 'AtTXCenter',
  OrganOffOCS = 'OrganOffOCS',
  ServiceCompleted = 'ServiceCompleted',
  ServiceDeclined = 'ServiceDeclined',
  ReturningToBase = 'ReturningToBase',
  Finished = 'Finished',
  Closed = 'Closed',
  Accepted = 'Accepted',
  New = 'New',
  OrTimeConfirmed = 'OrTimeConfirmed',
  QuoteReceived = 'QuoteReceived',
  QuoteSent = 'QuoteSent',
  QuoteRejected = 'QuoteRejected',
  QuoteApproved = 'QuoteApproved',
  Deleted = 'Deleted',
}

export enum CaseStatusForNotification {
  TXCenterDraft = 'TX Center Draft',
  ClinicalScreening = 'Clinical Screening',
}

export enum CustomerCaseStatus {
  Undefined = 'Undefined',
  Draft = 'Draft',
  UnderClinicalScreening = 'UnderClinicalScreening',
  CaseInitiatedForOCS = 'CaseInitiatedForOCS',
  CaseDeclined = 'CaseDeclined',
  LogisticsQuoteReceived = 'LogisticsQuoteReceived',
  LogisticsQuoteDeclined = 'LogisticsQuoteDeclined',
  LogisticsQuoteRecalled = 'LogisticsQuoteRecalled',
  TeamDeploymentInProgress = 'TeamDeploymentInProgress',
  AtDonorHospital = 'AtDonorHospital',
  CaseCanceled = 'CaseCanceled',
  TransplantNotCompleted = 'TransplantNotCompleted',
  OrganOnOCS = 'OrganOnOCS',
  OrganInTransit = 'OrganInTransit',
  OrganAtTXCenter = 'OrganAtTXCenter',
  OrganOffOCS = 'OrganOffOCS',
  NOPServiceCompleted = 'NOPServiceCompleted',
  NOPInvoiceReceived = 'NOPInvoiceReceived',
  CaseClosed = 'CaseClosed',
  PendingServiceApproval = 'PendingServiceApproval',
  ServiceRejectedByTxc = 'ServiceRejectedByTxc',
}

export type CaseStatusType = {
  status: CaseStatus;
  customerCaseStatus: CustomerCaseStatus;
  // TODO caseOutcome may be only: ServiceDeclined, Declined, ServiceCompleted
  caseOutcome?: CaseStatus | null;
  outcomeData?: OutcomeData;
};
